<div class="player-bar-container" >
<!--  @if (isNativeMode) {-->
<!--    <audio [src]="source.currentTrack()?.url" controls></audio>-->
<!--  } @else {-->
    <div class="d-flex align-center box1" style="margin-left: 5px">
      <div class="close-icon">
        <mat-icon (click)="closePlayer()">cancel</mat-icon>
      </div>

      <div class="marquee-container">
        <div class="marquee-content">
          <div style="font-size: 16px; color: grey">      {{source.currentTrack()?.name}}</div>
          <div style="font-size: 12px; color: grey">      {{source.currentTrack()?.author}}</div>
        </div>
      </div>
      <!--    <div style="    width: 100px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">-->
      <!--      <div style="font-size: 16px; color: grey">      {{source.currentTrack().name}}</div>-->
      <!--      <div style="font-size: 12px; color: grey">      {{source.currentTrack().author}}</div>-->

      <!--    </div>-->

    </div>
    <div style="width: 100%; height: 30px;" class="d-flex justify-between align-center box2">
      <span style="min-width: 40px">{{currentTime()}}</span>

      @if (isTrackLoading()) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      } @else if (isNativeMode()) {
        <mat-slider min="0" max="100" step="1" style="width: 100%">
          <input matSliderThumb [value]="progress()" (valueChange)="setTrackPosition($event)">
        </mat-slider>
      }
      <div #player style="width: 100%; height: 30px;" [ngClass]="{'hidden': isTrackLoading() || isNativeMode()}">
      </div>

      <span style="min-width: 40px; padding-left: 8px; padding-right: 32px">{{duration()}}</span>
    </div>

    <div class="d-flex justify-start align-center box3" style="padding-right: 5px; gap: 5px">
      <mat-icon>volume_mute</mat-icon>
      <mat-slider
        style="margin: 0"
        disableRipple
        max="100"
        min="0"
        step="1"
      >
        <input matSliderThumb [(ngModel)]="volume">
      </mat-slider>
      <!--    <div class="d-flex justify-between align-center">-->
      <mat-icon (click)="prevTrack()" class="control-icon ml-12" [class.control-icon-disabled]="!source.nearTracksData().previous">skip_previous</mat-icon>
      <mat-icon (click)="play()" class="control-icon" [class.control-icon-disabled]="isTrackLoading()">{{source.isPlaying() ? 'pause' : 'play_arrow'}}</mat-icon>
      <mat-icon (click)="nextTrack()" class="control-icon" [class.control-icon-disabled]="!source.nearTracksData().next">skip_next</mat-icon>
      <!--    </div>-->
    </div>
<!--  }-->
  <!--  <button (click)="pause()">&#45;&#45;</button>-->
</div>
